import { getBoxCopy, getPresentationCopy } from '../copy';

/** Visible copy for the cart packaging block: Figma frames 7-8 unless noted. */
export const CART_COPY = {
  title: 'Gift Wrap Options',
  viewSelection: 'View Selection',
  closeSelection: 'Close Selection',
  // ALBAU-884 (not drawn in Figma).
  removeAll: 'Remove gifting options',
  luxeDetail: 'Hand-tied with ribbon',
  photo: '1 image uploaded',
  seal: 'Wax seal',
  // ALBAU-900 (not drawn in Figma): a card's or insert's typed texts, in the order shown. Labelled only when
  // there are two or more; one text stays unlabelled as Figma frame 8 draws it.
  textLabels: { UVFrontText: 'Front', UVBackText: 'Back', UVInsideText: 'Inside', PersonalisationCard: 'Message' }
};

/** Category label shown on each panel (Figma casing) and the word used in the ticket's block label. */
export const CATEGORIES = {
  box: { label: 'Box:', word: 'BOX' },
  giftBag: { label: 'Gift Bag:', word: 'GIFT BAG' },
  giftSet: { label: 'Gift Set:', word: 'GIFT SET' },
  keepsake: { label: 'Keepsake:', word: 'KEEPSAKE' },
  // ALBAU-899 (not drawn in Figma): "Box insert" as step 3 and the old modal's summary name it.
  insert: { label: 'Box insert:', word: 'INSERT' },
  card: { label: 'Card:', word: 'CARD' },
  seal: { label: 'Wax Seal:', word: 'WAX SEAL' },
  other: { label: 'Gift Wrap:', word: 'GIFT WRAP' }
};

/** The journey's order: box (step 1), bag, set or keepsake (step 2), then step 3's insert before its cards. */
export const CATEGORY_ORDER = ['box', 'giftBag', 'giftSet', 'keepsake', 'insert', 'card', 'seal', 'other'];

/**
 * Names the journey itself shows (packaging/copy.js), so the cart repeats the customer's choices. Getters, so
 * each name is resolved when used and picks up the theme settings (window.giftWrapData is set by an inline
 * script after the cart drawer markup; the getters fall back to the defaults when it is absent).
 */
export const JOURNEY_NAMES = {
  get luxe() {
    return getBoxCopy('luxe').name;
  },
  get signature() {
    return getBoxCopy('signature').name;
  },
  get keepsake() {
    return getPresentationCopy('keepsake').name;
  },
  get personalisedBag() {
    return getPresentationCopy('bag').name;
  },
  get pair() {
    return getPresentationCopy('pair').name;
  }
};
